import { Outlet, useParams } from 'react-router-dom'

import useGetObject from '@app/hooks/useGetObject'
import Header from '@app/pages/basicCards/components/header'
import { PageStack } from '@app/shared/layout'

const Show = () => {
  const { nodeId, strategyId } = useParams()

  const basicCard = useGetObject(nodeId, 'basicCard')

  return (
    <PageStack bg="bg">
      <Header basicCard={basicCard} strategyId={strategyId} />
      <Outlet />
    </PageStack>
  )
}

export default Show
